import { useState, useEffect } from "react";
import { ProdutoNFCeDto } from "../../../NFCe/NFCe.Dto";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../../NFe.Dto";

export function NFeCadastroItemLoad() {
  const [dataProdutoNFe, setDataProdutoNFe] = useState<ProdutoNFCeDto[]>(() => {
    const nf = getLocal<NFeDto>(STORAGENFE_KEY);
    const itens = nf?.itens ?? [];
    return [...itens].sort((a, b) => {
      const seqA =
        a.sequencia != null && a.sequencia > 0
          ? a.sequencia
          : a.index != null && a.index > 0
          ? a.index
          : 0;
      const seqB =
        b.sequencia != null && b.sequencia > 0
          ? b.sequencia
          : b.index != null && b.index > 0
          ? b.index
          : 0;
      return seqA - seqB;
    });
  });

  useEffect(() => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      itens: dataProdutoNFe,
    });
  }, [dataProdutoNFe]);

  return { dataProdutoNFe, setDataProdutoNFe };
}
